import React, { useContext, useState } from "react";
import MCard, { MCardProps } from "components/Shared/MCard";
import { connect } from "react-redux";
import { CaseHeaderView, MCard as MCardServer } from "interfaces/Mueller.Business.Models";
import { caseHeaderV2Selector } from "selectors/homeowner/caseForms/caseHeaderV2";
import { userHasRight } from "selectors/rights";
import { CASE_HISTORY_CARD_VIEW, CASE_HISTORY_INTERNAL_NOTES_VIEW } from "typeConstants/rights";
import CompactHistory from "components/Homeowner/History/CompactHistory";
import { Button, Cell } from "react-md";
import { cancelCase } from "actions/homeowner/caseforms";
import { DialogContext, DialogProviderValue } from "components/Shared/DialogProvider";
import { TextField } from "react-md";
import { isAppraisalCase } from "components/Shared/Functions";
import { MSpinner } from "components/Shared";

interface Props {
  caseHeader: CaseHeaderView;
  cancelCase: (controlNumber: number, comments: string, callback?: () => void) => void,
  refreshMethod: () => void,
  cards: MCardServer[],
  viewCaseHistoryCard: boolean,
  viewInternalNotesInput: boolean,
  canCancel: boolean,
  handleSave: MCardProps["onEditFinished"],
};

const LimitedCaseView = ({
  caseHeader,
  cancelCase,
  refreshMethod,
  cards,
  viewCaseHistoryCard,
  viewInternalNotesInput,
  canCancel,
  handleSave,
}: Props) => {
  const [isCancelling, setIsCancelling] = useState(false);
  const dialog = useContext<DialogProviderValue>(DialogContext);
  
  let controlNumber = parseInt(caseHeader.caseHeaderDto.caseInfo.controlNumber);

  const showCancelCaseDialog = (showCommentRequired = false) => {
    let { surveyAddress } = caseHeader.caseHeaderDto.policyInfo;
    let commentsRef = { value: "" };

    dialog.show("Cancel Case",
      <>
        <p>Control # <b>{`${controlNumber}`}</b></p>
        <p>Survey Address <b>{`${surveyAddress.address1} ${surveyAddress.city}, ${surveyAddress.state} ${surveyAddress.zip}`}</b></p>
        <TextField
          rows={1}
          className="cancel-comment"
          onChange={comments => commentsRef.value = comments as string}
          error={showCommentRequired}
          errorText={showCommentRequired ? "Comments are required to cancel a case" : null}
        />
      </>,
      [
        { isPrimary: false, label: "Back", onClick: () => {} },
        { isPrimary: true, label: "Confirm", onClick: () => {
          if (!commentsRef.value?.length) {
            showCancelCaseDialog(true);
          } else {
            setIsCancelling(true);
            cancelCase(controlNumber, commentsRef.value, () => {
              setIsCancelling(false);
              refreshMethod();
            });
          }
        } },
      ],
      { width: 400 }
    );
  };

  return (
    <div>
      {(isCancelling || !cards?.length) ? <MSpinner /> :
      <>
      {
        caseHeader?.caseHeaderDto?.caseInfo?.limitedView?.reason && (
        <Cell size={12}>
          <MCard className="limited-case-view-reason" title={<>{caseHeader.caseHeaderDto.caseInfo.limitedView.reason}{canCancel && <Button primary raised onClick={() => showCancelCaseDialog()}>Cancel Case</Button>}</>} />
        </Cell>
      )}
      {cards.filter(c => c.showOnLimitedView).map(c => (
        <Cell size={12}>
          <MCard
            {...(c as MCardProps)} // cast here to avoid typescript yelling over incompatible types, guess i could list em out one by one instead of spreading
            key={c.key}
            onEditFinished={handleSave}
          />
        </Cell>
      ))}
      {viewCaseHistoryCard &&
        <Cell size={12}>
          <MCard title="History">
            <CompactHistory controlNumber={controlNumber} viewInternalNotesInput={viewInternalNotesInput} />
          </MCard>
        </Cell>}
      </>}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  cancelCase(controlIdNumber, comments, callback) {
    dispatch(cancelCase(controlIdNumber, comments, callback));
  },
});

const mapStateToProps = state => {
  return {
    caseHeaderV2: caseHeaderV2Selector(state),
    fetchingCaseHeaderV2: state.caseForms.fetchingCaseHeaderV2,
    viewCaseHistoryCard: userHasRight(CASE_HISTORY_CARD_VIEW)(state),
    viewInternalNotesInput: userHasRight(CASE_HISTORY_INTERNAL_NOTES_VIEW)(state),
    canCancel: state.caseForms.caseHeader.canCancelCase && !isAppraisalCase(state.caseForms.caseHeader),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LimitedCaseView);
